/* eslint-disable no-underscore-dangle */
import React, { PureComponent } from 'react';
import { graphql } from 'react-relay';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import styled from 'react-emotion';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { ITEMS_LIST_VIEW_PAGINATION_KEY } from '~/modules/coreUI/components/pagination';
import SortingDropdown, { ITEMS_LIST_SORTING_DROPDOWN_KEY } from '~/modules/ecommerceProducts/components/SortingDropdown';

import withRefetchQuery from '~/modules/core/utils/relayHelpers/withRefetchQuery';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import PaginationBox from '~/modules/coreUI/components/pagination/PaginationBox';
import PaginationTextInfo from '~/modules/coreUI/components/pagination/PaginationTextInfo';

import VendorCard from '../../vendor/VendorCard';

const ItemsListViewUI = withMedia(styled.div`
  display: grid;
  width: 100%;

  grid-gap: ${props => 1.5 * props.theme.new.spacer}px;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${props => (props.media.minMobile ? 500 : 280)}px, auto)
  );
`);

class SellingShops extends PureComponent {
  componentDidUpdate = () => {
    if (this.props.queryResult !== null) {
      if (!this.shopsLoaded) this.props.onShopsLoaded();
      this.shopsLoaded = true;
    }
  }

  render = () => {
    const { queryResult } = this.props;

    return (
      <Column fullWidth spaceBetween={1} leftAligned>
        <Row fullWidth spaceBetweenJustified>
          <Label size={['sm', 'lg']}>{i18next.t('ecommerceCoreUI:Product.sellingShops.subTitle')}</Label>
          <SortingDropdown />
        </Row>
        <PaginationTextInfo />
        <ItemsListViewUI>
          {queryResult
            && queryResult.vendor_variants_search.result.map(variant => (
              <VendorCard variantInfo={variant} key={`vc_${variant.__id}`} />
            ))}
        </ItemsListViewUI>
        <Row fullWidth centerJustified>
          <PaginationBox />
        </Row>
      </Column>
    );
  };
}

SellingShops.defaultProps = {
  queryResult: null,
};

SellingShops.propTypes = {
  queryResult: PropTypes.shape({}),
  onShopsLoaded: PropTypes.func.isRequired,
};

const fragment = {
  queryResult: graphql`
    fragment SellingShops_queryResult on Query
      @argumentDefinitions(input: { type: "VendorVariantsSearchInput" }) {
      vendor_variants_search(input: $input) {
        related_sorts {
          name
          display_name
          selected
        }
        result {
          ...VariantData_variantInfo
        }
        page_info {
         ...PaginationData_pageInfo
        }
        errors {
          field
          messages
          code
        }
      }
    }
  `,
};

const query = graphql`
  query SellingShopsQuery($input: VendorVariantsSearchInput) {
    ...SellingShops_queryResult @arguments(input: $input)
  }
`;

export default withRouter(
  withRefetchQuery(
    SellingShops,
    query,
    fragment,
    SellingShops,
    props => ({
      input: {
        root_variant_id: parseInt(props.match.params.slug.split('-')[0], 10),
        page: {
          offset: 0,
          limit: 6,
        },
      },
    }),
    {
      [ITEMS_LIST_SORTING_DROPDOWN_KEY]: {
        reset: [ITEMS_LIST_VIEW_PAGINATION_KEY],
      },
    },
    {
      sortingInfo: queryResult => _.cloneDeep(queryResult.vendor_variants_search.related_sorts),
      pageInfo: queryResult => _.cloneDeep(queryResult.vendor_variants_search.page_info),
    },
  ),
);
